module.exports = __webpack_public_path__ + "static/img/swiper1.32e8f48.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/swiper1.jpeg
// module id = LR7w
// module chunks = 0